import React from 'react'
import Filter from './Filter'
import WorkspaceTable from '../../Table'
import { NavLink, useHistory } from 'react-router-dom'
import { CompanyDownPaymentConsumer } from '../../../../CompanyDownPaymentContext'
import { SearchLoader } from '../../../Loader/SearchLoader'
import Alert from '@material-ui/lab/Alert'
import { FormattedMessage } from 'react-intl'
import EmptyResult from '../../../EmptyResult'
import {
  Box,
  Button,
  ButtonGroup,
  ClickAwayListener,
  Container,
  Grow, MenuItem,
  MenuList,
  Paper,
  Popper
} from '@material-ui/core'
import { useStyles } from './Styles'
import { NamedRoutes } from '../../../../routes'
import { formatRoute } from 'react-router-named-routes'
import { isEmpty } from '../../../../utils/helpers'
import { FormLoader } from '../../../Loader/FormLoader'
import AddNewDownPaymentDialog from './AddNewDownPaymentDialog'
import UnAuthorize from '../../../UnAuthorize'
import { sm } from '../../../../utils/ResponsiveUtility'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'

const CompanyDownPayment = ({ selectedCompany, getDownPaymentRequests, setBreadCrumbLinks, setBreadCrumbCurrent }) => {

  const classes = useStyles()
  let history = useHistory()
  const btnOptions = [
    {
      text: <FormattedMessage id='PaymentsContent.ActionLinks.PaymentRequests'/>,
      action: () => history.push({
        pathname: formatRoute(NamedRoutes.workspace.company.paymentRequests, { id: selectedCompany.id })
      })
    },
    {
      text: <FormattedMessage id='PaymentsContent.ActionLinks.PaymentReceipts'/>,
      action: () => history.push({
        pathname: formatRoute(NamedRoutes.workspace.company.paymentReceipts, { id: selectedCompany.id })
      })
    },
    {
      text: <FormattedMessage id='workspaceMenu.link.item64'/>,
      action: () => history.push({
        pathname: formatRoute(NamedRoutes.workspace.company.payments, { id: selectedCompany.id })
      })
    }
  ]

  React.useEffect(() => {
      if (!!setBreadCrumbLinks && !!selectedCompany && !isEmpty(selectedCompany)) {
        setBreadCrumbLinks((prevLinks) => [...prevLinks,
          {
            key: 'BreadcrumbLink-2',
            name: selectedCompany.taxpayer_name,
            link: formatRoute(NamedRoutes.workspace.company.view, { id: selectedCompany.id })
          }])
        setBreadCrumbCurrent(<FormattedMessage id='workspaceMenu.link.item66'/>)
      }
      if (!!getDownPaymentRequests) {
        getDownPaymentRequests()
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef(null)

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }

    setOpen(false)
  }

  const [width, setWidth] = React.useState(document.body.clientWidth)

  let Mobile = (width < sm)
  React.useEffect(() => {
    const getWidth = () => {
      setWidth(document.body.clientWidth)
    }
    window.addEventListener('resize', getWidth)
    return () => {
      window.removeEventListener('resize', getWidth)
    }
  }, [width])

  const [isCompanyUnderage, setIsCompanyUnderage] = React.useState(false)
  React.useEffect(() => {
      if (!!Object.keys(selectedCompany || {}).length) {
        setIsCompanyUnderage(!!selectedCompany?.is_underage)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedCompany])
  return (
    <>
      {!!selectedCompany && !isEmpty(selectedCompany) &&
      <Container disableGutters maxWidth="lg" className={classes.paymentsActionLinksContainer}>
        {!!Mobile ?
          <>
            <ButtonGroup variant="contained" color="primary" ref={anchorRef} aria-label="split button">
              <Button onClick={btnOptions[0].action}>{btnOptions[0].text}</Button>
              <Button
                color="primary"
                size="small"
                aria-controls={open ? 'split-button-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-label="select merge strategy"
                aria-haspopup="menu"
                onClick={handleToggle}
              >
                <ArrowDropDownIcon/>
              </Button>
            </ButtonGroup>
            <Popper open={open} className={classes.btnPopper} anchorEl={anchorRef.current} role={undefined} transition
                    disablePortal>
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList id="split-button-menu">
                        {btnOptions.map((btnObj, index) => (
                          <MenuItem
                            key={index}
                            selected={index === 0}
                            onClick={btnOptions[index].action}
                          >
                            {btnObj.text}
                          </MenuItem>
                        ))}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </> :
          <>
            <ButtonGroup size="large" variant={'contained'} color="primary"
                         aria-label="large outlined primary button group">
              <Button onClick={btnOptions[0].action}>
                {btnOptions[0].text}
              </Button>
              <Button onClick={btnOptions[1].action}>
                {btnOptions[1].text}
              </Button>
            </ButtonGroup>
            <ButtonGroup size="large" variant={'contained'} color="primary"
                         aria-label="large outlined primary button group">
              <Button onClick={btnOptions[2].action}>
                {btnOptions[2].text}
              </Button>
            </ButtonGroup>
          </>
        }
      </Container>
      }
      <CompanyDownPaymentConsumer>
        {({
            downPaymentRequestsLoading, downPaymentRequestsFailure, downPaymentRequestsFailure403,
            downPaymentRequests, DownPaymentRequestsHeaderColumns, hasMoreDownPaymentRequests,
            downPaymentRequestsRefreshLoading, newDownPaymentSuccess, getDownPaymentAmountRange,
            resetAllNewDownPaymentStates, handleSubmitDownPaymentRequestsFilter, downPaymentRange, handleNewDownPaymentSubmit,
            companyFailureUnderage, companyFailureUnderageMessage
          }) => (
          <Box p={2} className={'back-white'}>

            {!!downPaymentRequestsFailure403 ? <UnAuthorize/> :
              (!!isCompanyUnderage && !!companyFailureUnderage ?
                <Alert severity="error">
                  {companyFailureUnderageMessage}
                  <FormattedMessage id='Underage.ErrorAlert' values={{
                    a: chunks => <NavLink to={formatRoute(NamedRoutes.workspace.company.delegates, { id: selectedCompany.id })}>{chunks}</NavLink>
                  }}/></Alert>
                  : (!!selectedCompany?.is_inherited_reality_owner ?
                    <Alert severity="error" className={classes.linkCompanyErrorMessage}>
                      <FormattedMessage 
                        id='InheritedReality.taxService.ErrorAlert' 
                        values={{
                          a: chunks => <NavLink
                            to={formatRoute(NamedRoutes.workspace.company.delegates, { id: selectedCompany.id })}>{chunks}</NavLink>
                        }}
                      />
                    </Alert>
                : (!!downPaymentRequestsFailure &&
                  <Alert severity="error"><FormattedMessage id='BasicInfo.FormErrorAlert'/></Alert>
                )))
            }

            {!downPaymentRequestsFailure403 && !companyFailureUnderage && !selectedCompany?.is_inherited_reality_owner && !(!!isCompanyUnderage && !!downPaymentRequestsLoading) &&
            <Filter submitForm={handleSubmitDownPaymentRequestsFilter}/>
            }

            {!!downPaymentRequestsLoading && <SearchLoader loading={true}/>}
            {(!!downPaymentRequests && !!downPaymentRequests.length) ?
              <WorkspaceTable
                loadRows={getDownPaymentRequests}
                hasMoreRows={hasMoreDownPaymentRequests}
                rows={downPaymentRequests}
                columns={DownPaymentRequestsHeaderColumns}
                isDownPayment={true}
                size={'small'}/>
              :
              <>
                {!!downPaymentRequestsRefreshLoading &&
                <div className={classes.refreshWrapper}><FormLoader loading={true}/></div>}
                {!downPaymentRequestsLoading && !downPaymentRequestsRefreshLoading && !downPaymentRequestsFailure403 && !companyFailureUnderage &&
                <EmptyResult isPayments={true}/>}
              </>
            }
            {!downPaymentRequestsLoading && !downPaymentRequestsFailure403 && !companyFailureUnderage && !selectedCompany?.is_inherited_reality_owner &&
            <AddNewDownPaymentDialog submitForm={handleNewDownPaymentSubmit}
                                     getDownPaymentAmountRange={getDownPaymentAmountRange}
                                     getDownPaymentRequests={getDownPaymentRequests}
                                     newDownPaymentSuccess={newDownPaymentSuccess}
                                     downPaymentRange={downPaymentRange}
                                     resetAllNewDownPaymentStates={resetAllNewDownPaymentStates}/>}
          </Box>
        )}
      </CompanyDownPaymentConsumer>

    </>
  )
}

export default CompanyDownPayment
